import React, { useState } from 'react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { X, Send } from 'lucide-react';

const PreReservationModal = ({ isOpen, onClose, onConfirm, resourceName, projectTitle, isRMInitiated = false }) => {
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsSubmitting(true);
    await onConfirm(message.trim());
    setMessage('');
    setIsSubmitting(false);
  };

  const handleClose = () => {
    setMessage('');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold" style={{ color: '#1B3240' }}>
            <Send className="inline w-5 h-5 mr-2" style={{ color: '#62D84E' }} />
            {isRMInitiated ? 'Apply for Project' : 'Pre-Reserve Resource'}
          </h3>
          <button onClick={handleClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            {isRMInitiated 
              ? 'You are about to apply for this project with your resource:' 
              : 'You are about to send a pre-reservation request for:'}
          </p>
          <div className="bg-blue-50 p-3 rounded-lg">
            {isRMInitiated ? (
              <>
                <p className="font-medium text-sm">Project: {projectTitle}</p>
                <p className="text-xs text-gray-600 mt-1">
                  With resource: {resourceName}
                </p>
              </>
            ) : (
              <>
                <p className="font-medium text-sm">{resourceName}</p>
                {projectTitle && (
                  <p className="text-xs text-gray-600 mt-1">
                    For project: {projectTitle}
                  </p>
                )}
              </>
            )}
          </div>
        </div>

        <div className="mb-6">
          <Label className="mb-2 block">
            Personalize your message (optional)
          </Label>
          <Textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={isRMInitiated 
              ? "Add a message to the Project Manager to highlight why your resource is a good fit..."
              : "Add a personal message to the Resource Manager to qualify your request or provide additional context..."}
            rows={5}
            className="w-full"
          />
          <p className="text-xs text-gray-500 mt-1">
            {isRMInitiated 
              ? 'This message will be sent to the Project Manager along with your application.'
              : 'This message will be sent to the Resource Manager along with your pre-reservation request.'}
          </p>
        </div>

        <div className="flex gap-3">
          <Button
            onClick={handleConfirm}
            style={{ backgroundColor: '#62D84E' }}
            className="flex-1"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : (isRMInitiated ? 'Submit Application' : 'Send Pre-Reservation Request')}
          </Button>
          <Button
            onClick={handleClose}
            variant="outline"
            className="flex-1"
            disabled={isSubmitting}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PreReservationModal;
